import React, { FC } from 'react';
import 'react-dates/initialize';

import { useTranslations } from '@lang';
import { SingleMobileInput, StyledMobileTextLabel } from './SingleMobileInput';
import { DateInputProps } from '../types';

import { MobilePickerWrapper } from './MobileInput.styles';

export const MobileInput: FC<DateInputProps> = ({ startDate, onDateChange }) => {
  const { t } = useTranslations();
  return (
    <MobilePickerWrapper>
      <StyledMobileTextLabel htmlFor="date-range-start-date">
        {t('common.date')}
      </StyledMobileTextLabel>
      <SingleMobileInput onDateChange={onDateChange} startDate={startDate} />
    </MobilePickerWrapper>
  );
};
